<template>
  <div>
    <center class="mb-8 white--text">
      <h1 class="display-2 mt-4" id="home-main-title">Velkommen!</h1>
      <p
        class="font-weight-thin mb-4 mt-2"
      >Her kan du lese litt om mine opplevelser så langt i livet</p>
      <v-row>
        <v-col>
          <CategorySelector
            class="jumpy"
            title="Prosjekter"
            shortDescription="Prosjekter jeg arbeider med"
            routerLinkTo="more-info/prosjekter"
            color="blue"
            logo="fas fa-project-diagram"
            imageUrl="pretty-sky.png"
          />
        </v-col>
        <v-col>
          <CategorySelector
            class="jumpy"
            title="Karriere"
            shortDescription="Hvor har jeg jobbet?"
            routerLinkTo="more-info/karriere"
            color="orange"
            logo="fas fa-university"
            imageUrl="pretty-bear.jpg"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <CategorySelector
            class="jumpy"
            title="Litt om meg selv"
            shortDescription="Hobyer, interesser etc."
            routerLinkTo="more-info/me"
            color="red"
            logo="fas fa-user-astronaut"
            imageUrl="pretty-boat.jpg"
          />
        </v-col>
        <v-col>
          <CategorySelector
            class="jumpy"
            title="Sertifiseringer"
            shortDescription="Kunnskap er alltid greit å ha"
            routerLinkTo="more-info/sertifikater"
            color="brown"
            logo="fas fa-certificate"
            imageUrl="pretty-waves.jpg"
          />
        </v-col>
        
      </v-row>
    </center>

    <div>
      <center style="margin-top:10vh;">
        <MoreDetails
          title="Kontaktinfo"
          description="I tilfelle du ønsker å kontakte meg"
          imageUrl="https://lh3.googleusercontent.com/0IQ9TPE9If9XzqOBQqcheFA2igkIcqSO83ZPhivvbuO3BptG3DUohC4SF1tORBmVQm44Uxhr63RTp_VYUotkTGRjPSCM198T-Kmqi-As9zlB0tTYYFjiKjcgid12MOxhY3VFNQBs1LXgzIqDr9V8FjRp9gQdnWeI2cEs6TfYsZMiW5WdMFCNCnJHRjO3_busbloViSgxvz0SIO6fuDW9lxODXzuBw79ZSY1gDL6UyfB6oFbPbxI6xl3ckiB1WG7b9vt2kSxJOyvhEJZ6LGgqhlqgN3iN5pFd5Km9Bjf0sfiSnvaZkHgO5ZJWsBnbHmPEnCKGBSgBrtxPiU_rCybHgkVxc182v9gl5_lkrEcbLAN4mi-pIbIAUeqK3Q_V-AOMIz5lRPdqDcULdoQUmpPgWwmY2q6vsBc43DWgxgOGnUjlmwTaGboaRJ6Q7e0jKXX72JvwxidZg2vuUpH6MbIfmG5fYK7rtA6kgrDCK9v0fegNpudYs2RB6N3INYm_5k_nrBrYzrNWjp7zBzqhf-cYuhsW4x19uVlQ6JJZWzwTaVM3-dAw2ZB2nlDJrTGGX0iHuWK4ZK3AQT5z_A0Ji0YOD5om3I6YuOoWYgjqiazQ0OH5CVikAfnvFiqGI-OGFJxr0ZVKfp7t_BsU-FHOFoT9I8AVZlgFqR5KQ4ZbPt2HkMwbNo2400B774mrmT-B=w1734-h975-no"
        >
          <h1 class="mt-4">Takker for at du har besøkt denne siden !</h1>
          <p class="grey-text">Håper du har en fin dag videre</p>

          <hr class="mt-8" />
          <v-row>
            <v-col>
              <p class="mt-4">
                <v-icon>fas fa-phone</v-icon>
                <strong class="ml-4">482 613 07</strong>
              </p>
            </v-col>
            <v-col>
              <p class="mt-4">
                <v-icon>fas fa-envelope</v-icon>
                <strong class="ml-4">krispetter@gmail.com</strong>
              </p>
            </v-col>
          </v-row>

          <hr style="margin-bottom:10vh;" />

          <h2 class=".display-2 mt-8">
            Hvis du har lyst å se noen bilder jeg har tatt, så kan du ta en titt her!
          </h2>
          <h3>
            <a target="_blank" href="https://photos.app.goo.gl/dDBP4YKt5W9icVPL7">Link til Google photo album</a>
          </h3>
        </MoreDetails>
      </center>
    </div>
    <center>
      <v-row>
        <v-col v-for="color in colors" v-bind:key="color">
          <v-avatar
            class="zoom"
            :color="color"
            size="62"
            @mouseover="() => changeBackgroundcolor(color)"
          ></v-avatar>
        </v-col>
      </v-row>
    </center>
  </div>
</template>

<script>
import CategorySelector from "@/components/CategorySelector";
import MoreDetails from "@/components/MoreDetails";
export default {
  components: { CategorySelector, MoreDetails },

  data() {
    return {
      colors: ["#6880ed", "#5b0d0d", "#15266b"]
    };
  },

  methods: {
    changeBackgroundcolor(color) {
      const content = document.getElementById("content");
      content.style.backgroundColor = color;
    }
  },

  async mounted() {
    const elements = document.querySelectorAll(".jumpy");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("animated", "bounceIn");
    }

    await new Promise(r => setTimeout(r, 1000));
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("animated", "bounceIn");
    }
  }
};
</script>

<style scoped>
</style>